import {
  getTheme,
  getPrivacyPolicyType,
  getPrivacyPolicyPage,
  getPrivacyPolicyUrl,
  getAudience,
} from '../selectors/app-settings';
import { StoreState } from '../store';
import { TranslationKey, PrivacyPolicyType } from '@src/types';
import { logger } from '@src/sevices/bi-logger/bi-logger-service';
import { isAppEnabled, getLiveSiteUrl, isDeclineAllEnabled } from '../selectors/ui-settings';

const getTranslationsChangeStatus = (store: StoreState, key: TranslationKey) =>
  store.currentState?.appSettings.texts[key] === store.pendingState?.appSettings.texts[key] ? 'Not changed' : 'Changed';

const getPageUrl = (store: StoreState) => getLiveSiteUrl(store) + '/' + getPrivacyPolicyPage(store);

export const sendCookiesBannerUouSavePublishClick = async (store: StoreState) => {
  const isPageOnSite = getPrivacyPolicyType(store) === PrivacyPolicyType.PageOnSite;
  await logger.cookiesBannerUouSavePublishClick({
    banner_color: getTheme(store),
    consent_button_text: getTranslationsChangeStatus(store, TranslationKey.ConsentButton),
    settings_button_text: getTranslationsChangeStatus(store, TranslationKey.SettingButton),
    privacy_policy_link_text: getTranslationsChangeStatus(store, TranslationKey.PrivacyLink),
    general_text: getTranslationsChangeStatus(store, TranslationKey.PrivacyInfo),
    link_option: isPageOnSite ? 'Page On My Site' : 'External Web Address',
    url_privacy_policy: isPageOnSite ? getPageUrl(store) : getPrivacyPolicyUrl(store),
    audience: getAudience(store),
    save_button_text: getTranslationsChangeStatus(store, TranslationKey.SaveButton),
    essential_cookies_text: getTranslationsChangeStatus(store, TranslationKey.EssensialCategoryParagraph),
    marketing_cookies_text: getTranslationsChangeStatus(store, TranslationKey.MarketingCategoryParagraph),
    functional_cookies_text: getTranslationsChangeStatus(store, TranslationKey.FunctionalCategoryParagraph),
    analytics_cookies_text: getTranslationsChangeStatus(store, TranslationKey.AnalyticsCategoryParagraph),
    cookie_status: isAppEnabled(store) ? 'standard' : 'OFF',
    decline_all_button: isDeclineAllEnabled(store) ? 'on' : 'off',
  });
};

export enum PopupType {
  MissingPolicy = 'Privacy Policy link is missing',
  ResetLog = 'Reset cookie consent log',
  SomethingsWrong = 'something went wrong',
  Published = 'Cookie banner is published',
  SureYouWantToLeave = 'sure you want to leave',
  DisableApproval = 'Disable Wix’s standard cookie consent banner',
}

export enum PopupActionType {
  Close = 'close',
  RClick = 'right click',
  LClick = 'left click',
}

export const sendBIUserPopupCTA = async (type: PopupType, action: PopupActionType) => {
  await logger.cookiesBannerUouUserWithPopUpCta({
    pop_up_type: type,
    action,
  });
};

export enum AdvancedOptionsCTA {
  CustomizeCategoriesText = 'customize cookies categories text',
  ResetConsentLog = 'reset your consent log',
}

export const sendBIAdvancedOptionsCTA = (action: AdvancedOptionsCTA) =>
  logger.cookiesBannerUouAdvancedOptionsCta({ action });

export const sendBIDoNotSellMyData = () => logger.cookiesBannerUouAddADoNotSellDateLinkClick({});

export enum SetupPrivacyAction {
  LearnHow = 'learn how',
  SubLearnHow = 'sub learn how',
  SubLearnMore = 'sub learn more',
}

export const sendBISetupPrivacyClick = (action: SetupPrivacyAction) =>
  logger.cookiesBannerUouSetUpAPrivacyPolicyClicks({ action });

export const sendBIReviewRequirementsAlert = () => logger.cookiesBannerUouReviewRequirementsAlert({});

export const sendBIGetStartedClicked = (getStarted: boolean) =>
  logger.cookiesBannerUouCookieConsentBannerGetStartedClick({
    action: getStarted ? 'get started' : 'edit',
  });
